import {  deductStatus } from '../../functions/getValidations'


const formValidationSchema = {
  deductStatus,
}

export default formValidationSchema
